import { useState } from "react";
import { AlertTriangle, BellOff, CalendarClock, CheckCircle2, ChevronRight, MessageCircle, UserPlus, WifiOff, CreditCard } from "lucide-react";

const ICONS = {
  wa_down: WifiOff,
  grace: CreditCard,
  expiring: CalendarClock,
  reminders_failed: BellOff,
  bot_errors: AlertTriangle,
  lead: UserPlus,
  idle: AlertTriangle,
};

const SHOW_COLLAPSED = 5;

/**
 * Bandeja "Requiere atención": lo que hoy pide una acción tuya, cada item con su
 * acción directa (registrar pago, escribir por WhatsApp, abrir el detalle). Es la
 * pantalla que abres desde el cel; los datos vienen ya calculados del panel.
 */
export default function AttentionFeed({ items, onOpen, onPay }) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? items : items.slice(0, SHOW_COLLAPSED);

  return (
    <section className="sa-section sa-attention">
      <div className="sa-attention-head">
        <h2 className="sa-h2">Requiere atención {items.length > 0 && <span className="sa-count">{items.length}</span>}</h2>
      </div>

      {items.length === 0 ? (
        <div className="sa-attention-empty">
          <CheckCircle2 size={18} /> Todo en orden: nadie caído, nada por vencer, sin registros a medias.
        </div>
      ) : (
        <ul className="sa-attention-list">
          {visible.map((it) => {
            const Icon = ICONS[it.kind] || AlertTriangle;
            return (
              <li key={it.id} className={`sa-attn sev-${it.severity}`}>
                <button type="button" className="sa-attn-main" onClick={() => it.client ? onOpen(it.client, it.tab) : undefined} disabled={!it.client}>
                  <span className="sa-attn-icon"><Icon size={16} /></span>
                  <span className="sa-attn-text">
                    <span className="sa-attn-title">{it.title}</span>
                    <span className="sa-attn-detail">{it.detail}</span>
                  </span>
                  {it.client && <ChevronRight size={16} className="sa-chev" />}
                </button>
                <div className="sa-attn-actions">
                  {it.pay && (
                    <button type="button" className="sa-btn sa-btn-primary sa-btn-sm" onClick={() => onPay(it.client)}>
                      <CreditCard size={14} /> Registrar pago
                    </button>
                  )}
                  {it.waHref && (
                    <a className="sa-btn sa-btn-sm" href={it.waHref} target="_blank" rel="noopener noreferrer">
                      <MessageCircle size={14} /> WhatsApp
                    </a>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}

      {items.length > SHOW_COLLAPSED && (
        <button type="button" className="sa-linkbtn" onClick={() => setExpanded((v) => !v)}>
          {expanded ? "Ver menos" : `Ver ${items.length - SHOW_COLLAPSED} más`}
        </button>
      )}
    </section>
  );
}
